<template>
  <div class="date-filter text-center">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      offset-y
      left
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="dataLabel"
          prepend-icon="mdi-calendar"
          class="pt-4 mr-5"
          v-bind="attrs"
          dark
          v-on="on"
        />
      </template>

      <v-card>
        <v-row>
          <div class="">
            <v-list dense>
              <v-list-item-group
                v-model="selectedItem"
                color="purple"
              >
                <v-list-item
                  v-for="(period, index) in relativePeriodsList()"
                  :key="index"
                  @click="moveCalendar(period)"
                >
                  <v-list-item-content>
                    <v-list-item-title v-text="period.label" />
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </div>
          <v-row>
            <vc-date-picker
              v-model="range"
              color="purple"
              class="d-sm-flex pt-3 ml-6"
              :columns="2"
              :max-date="maxDate"
              locale="pt-BR"
              mode="dateTime"
              :update-on-input="true"
              is24hr
              is-range
            />
          </v-row>
        </v-row>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <DsButton
            color="secondary"
            @click="cancelAction"
          >
            Cancelar
          </DsButton>
          <DsButton
            color="primary"
            @click="saveAction"
          >
            Filtrar
          </DsButton>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import moment from 'moment';
import { DsButton } from '@ds/components';
import { NORMALIZED_FULL_PATTERN, DATE_PERIOD } from '@/utils/date';

export default {
  name: 'DateFilter',
  components: {
    DsButton
  },
  props: {
    initialDate: {
      type: Object,
      default() {
        return {
          start: moment()
            .subtract('6', 'day')
            .startOf('day'),
          end: moment().endOf('day')
        };
      }
    },
    periodList: {
      type: Array,
      default() {
        return DATE_PERIOD;
      }
    },
  },
  data() {
    return {
      menu: false,
      dateFilter: true,
      dateRange: {
        start: moment()
          .subtract('6', 'day')
          .startOf('day'),
        end: moment().endOf('day')
      },
      showDateFilter: false,
      selectedItem: null,
      temporaryRange: {
        start: null,
        end: null
      },
    };
  },
  computed: {
    maxDate() {
      return moment().endOf('day')._d;
    },
    dataLabel() {
      return `${this.dateRange.start.format('L')} - ${this.dateRange.end.format(
        'L'
      )}`;
    },
    range: {
      get() {
        return {
          end: this.dateRange.end.format(),
          start: this.dateRange.start.format(),
        };
      },
      set(newDate) {
        this.temporaryRange.end = moment(newDate.end).endOf('day');
        this.temporaryRange.start = moment(newDate.start).startOf('day');
      }
    }
  },
  created() {
    this.temporaryRange = { ...this.dateRange };
  },
  mounted() {
    this.dateRange = this.initialDate;
  },
  methods: {
    moveCalendar(period) {
      period.moveToSpecificPeriod.bind(this)();
      this.menu = true;
    },
    relativePeriodsList() {
      return this.periodList.map(period => ({
        label: period.label,
        moveToSpecificPeriod() {
          this.dateRange.end = period.end;
          this.dateRange.start = period.start;

          this.temporaryRange.end = period.end;
          this.temporaryRange.start = period.start;
        }
      }));
    },
    dateHasChange() {
      const start = this.temporaryRange.start !== this.dateRange.start;
      const end = this.temporaryRange.end !== this.dateRange.end;
      return start || end;
    },
    setDateRange(start, end) {
      this.dateRange = { start, end };
    },
    cancelAction() {
      this.temporaryRange.start = this.dateRange.start;
      this.temporaryRange.end = this.dateRange.end;
      this.menu = false;
    },
    saveAction() {
      const startDate =
        this.temporaryRange.start._i || this.temporaryRange.start._d;
      const endDate =
        this.temporaryRange.end._i || this.temporaryRange.end._d;

      this.setDateRange(
        moment(startDate, NORMALIZED_FULL_PATTERN),
        moment(endDate, NORMALIZED_FULL_PATTERN)
      );

      this.$emit('change', this.dateRange);
      this.selectedItem = null;
      this.menu = false;
    },
  },
};
</script>

<style scoped lang="scss">
.date-picker {
  z-index: 9;
  width: 240px;
  cursor: pointer;
  background: transparent;
}

.theme--dark .date-picker {
  color: var(--ds-color-white-text);
}

.vc-grid-container {
  z-index: var(--zindex-100);
}

.v-menu__content {
  width: 710px;
  height: 435px;
  position: fixed;
  overflow: hidden;
  top: 120px !important;
  left: 245px !important;
  background-color: var(--ds-color-neutral);
  padding: 10px var(--ds-spacing-inset-sm) !important;
}

.v-card__actions {
  margin-top: var(--ds-spacing-inset-sm);

  .ds-button {
    margin: 0 var(--ds-spacing-inset-xs);
  }
}

.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none;
}

::v-deep {
  .vc-pane-container div:nth-child(3) {
    display: flex;
    justify-content: space-around;
  }

  .vc-container {
    border: none;
  }

  .vc-time-picker.vc-bordered {
    width: 100%;
    justify-content: center;
    border-color: transparent;
  }

  .vc-container.vc-is-dark {
    border-color: transparent;
    background-color: transparent;
  }

  .v-menu__content {
    position: absolute;
    left: 200px !important;
  }

  .v-text-field__slot {
    min-width: 190px;
  }

  .v-btn {
    text-transform: capitalize;

    &__content {
      font-weight: var(--ds-font-weight-semibold);
    }
  }
}
</style>
